/* eslint-disable indent */
const generateNewWindowContent = firstAnswer => {
  return `
    <html>
      <head>
        <title>Archivos Descargados</title>
      </head>
      <body>
        <h2>Archivos Descargados:</h2>
        <ul>
          ${firstAnswer
            .map(
              file =>
                `
         <li>
              ${file.name}
            </li>
          `
            )
            .join('')}
        </ul>
      </body>
    </html>
  `;
};
export default generateNewWindowContent;

// ${file.name ? '<span>✔️</span>' : ''}
